<div class="touchpoints-section">
  <div class="touchpoints-header d-flex align-items-center justify-content-between mb-3">
    <div class="d-flex align-items-center gap-3">
      <h2 class="card-title h4 m-0">Touchpoints</h2>
      <select class="form-select touchpoints-filter" [ngModel]="selectedType()"
        (ngModelChange)="selectedType.set($event)">
        <option [ngValue]="TouchpointType.Production">Production</option>
        <option [ngValue]="TouchpointType.Sales">Sales</option>
      </select>
    </div>
    <button class="btn btn-link p-0 text-dark" type="button" (click)="toggleCollapsed()"
      [attr.aria-expanded]="!isCollapsed()" aria-label="Toggle touchpoints">
      <i class="bi" [class.bi-chevron-up]="!isCollapsed()" [class.bi-chevron-down]="isCollapsed()"></i>
    </button>
  </div>

  @if (!isCollapsed()) {
  @if (isLoading()) {
  <groundworks-state-message type="loading" message="Loading touchpoints..." class="d-flex" />
  } @else if (hasError()) {
  <groundworks-state-message type="error" message="Error loading touchpoints." class="d-flex" />
  } @else {
  <div class="touchpoints-list">
    @if (filteredTouchpoints().length === 0) {
    <p class="text-muted">No {{ isSalesSelected() ? 'sales' : 'production' }} touchpoints found.</p>
    } @else {
    @for (touchpoint of filteredTouchpoints(); track touchpoint.id) {
    <div class="touchpoint-item mb-3">
      <div class="touchpoint-meta mb-1">
        <span class="fw-bold">{{ touchpoint.userDisplayName || touchpoint.createdBy }}</span>
        @if (touchpoint.sourceName) {
        <span> - {{ touchpoint.sourceName }}</span>
        }
        <span class="text-muted ms-2">{{ touchpoint.createdAt | utcToLocal | date:'MMM d, yyyy, h:mm a' }}</span>
      </div>
      <p class="touchpoint-content mb-1">{{ touchpoint.content }}</p>
    </div>
    }
    }
  </div>

  @if (!isSalesSelected()) {
  <div class="touchpoints-form mt-3">
    <textarea class="form-control mb-1" rows="3" [value]="newNote()" (input)="onNoteInput($event)"
      [disabled]="isSubmitting()" placeholder="Add a comment about this Job..." [attr.maxlength]="maxLength"></textarea>
    <div class="d-flex justify-content-between align-items-center">
      <small class="text-muted" [class.text-danger]="characterCount() > maxLength">
        {{ characterCount() }} / {{ maxLength }}
      </small>
      <button type="button" class="btn btn-dark mt-2" [disabled]="!isNoteValid() || isSubmitting()" (click)="addNote()">
        Add Note
      </button>
    </div>
  </div>
  }
  }
  }
</div>
